import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import { AcceptInvitationPage } from './pages/AcceptInvitation';
import { LoginPage } from './pages/LoginPage';
import { OtpPage } from './pages/OtpPage';
import { ForgotPage } from './pages/ForgotPage';
import { ResetPage } from './pages/ResetPage';
import { SelectPage } from './pages/SelectPage';
import { GoPage } from './pages/GoPage';

const antdTheme = {
  token: {
    colorPrimary: '#2f6ab0',
    fontFamily: "'Instrument Sans', system-ui, -apple-system, sans-serif",
  },
};

const qc = new QueryClient({
  defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } },
});

function App() {
  return (
    <ConfigProvider theme={antdTheme}>
      <QueryClientProvider client={qc}>
        <BrowserRouter>
          <Routes>
            {/* Landing on / just redirects to /login — that's what people want. */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/login/otp" element={<OtpPage />} />
            <Route path="/forgot" element={<ForgotPage />} />
            <Route path="/reset/:token" element={<ResetPage />} />
            <Route path="/select" element={<SelectPage />} />
            <Route path="/go/:token" element={<GoPage />} />
            <Route path="/invite/:token" element={<AcceptInvitationPage />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </ConfigProvider>
  );
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');
ReactDOM.createRoot(rootEl).render(<React.StrictMode><App /></React.StrictMode>);
